// extracted by mini-css-extract-plugin
module.exports = {"coverLink":"x-z","contentBox":"y-z","zapposPromoContainer":"z-z","zapposPromoGroupContainer":"A-z","promos":"B-z","bottom":"C-z","top":"D-z","right":"E-z","left":"F-z"};